import { SubscriptionPlan } from '@repo/graphql-types'

export const STUDIO_AI_PRICING_PLANS = {
  [SubscriptionPlan.StudioAiMonthly1900]: {
    tier: 'starter',
    name: 'Starter',
    cadence: 'monthly',
    priceUsd: 19,
    coins: 198_000,
  },
  [SubscriptionPlan.StudioAiYearly22800]: {
    tier: 'starter',
    name: 'Starter',
    cadence: 'annual',
    priceUsd: 228,
    coins: 2_460_000,
  },
  [SubscriptionPlan.StudioAiMonthly5900]: {
    tier: 'plus',
    name: 'Plus',
    cadence: 'monthly',
    priceUsd: 59,
    coins: 620_000,
  },
  [SubscriptionPlan.StudioAiYearly56400]: {
    tier: 'plus',
    name: 'Plus',
    cadence: 'annual',
    priceUsd: 564,
    coins: 7_680_000,
  },
  [SubscriptionPlan.StudioAiMonthly12900]: {
    tier: 'ultra',
    name: 'Ultra',
    cadence: 'monthly',
    priceUsd: 129,
    coins: 1_470_000,
  },
  [SubscriptionPlan.StudioAiYearly118800]: {
    tier: 'ultra',
    name: 'Ultra',
    cadence: 'annual',
    priceUsd: 1188,
    coins: 17_850_000,
  },
} as const

export type StudioAiPricingPlan = keyof typeof STUDIO_AI_PRICING_PLANS

export function isStudioAiPricingPlan(
  plan: string | null | undefined,
): plan is StudioAiPricingPlan {
  return Boolean(plan && Object.hasOwn(STUDIO_AI_PRICING_PLANS, plan))
}
